import React, { useContext } from "react";
import { Dialog, Container, Paper, Button, Stack, Box } from "@mui/material";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Slide from "@mui/material/Slide";

import { DataContext } from "../context/DataContext";
import Lottie from "lottie-react";
import unauthorized from "./media/unauthorized.json";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";

import { ThemeProvider } from "@mui/material/styles";
import { crearTema } from "../theme/theme";
import { EstadoError, PageHeader } from "./base";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Unautorized = () => {
  const { title, isUnautorized, isDarkMode, setIsUnautorized, icon } =
    useContext(DataContext);

  const tema = crearTema(isDarkMode ? "dark" : "light");

  let navigate = useNavigate();

  return (
    <div>
      <ThemeProvider theme={tema}>
        <Dialog
          fullScreen
          open={isUnautorized}
          TransitionComponent={Transition}
          PaperProps={{
            "aria-label": "Usuario no autorizado",
            sx: { bgcolor: "background.default" },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <img
                loading="lazy"
                src={icon}
                alt="Logo"
                style={{ height: 40 }}
              />
              <Typography
                sx={{
                  ml: 2,
                  flex: 1,
                  textAlign: "center",
                  fontWeight: 700,
                  color: "primary.main",
                }}
                variant="h5"
                component="div"
              >
                {`${title}`}
              </Typography>
            </Toolbar>
          </AppBar>

          <Container maxWidth={false} sx={{ py: 3 }}>
            <Paper sx={{ p: { xs: 2, md: 3 } }}>
              <PageHeader titulo="Usuario no autorizado" />

              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                alignItems={"center"}
                spacing={2}
              >
                {/* Ilustración decorativa */}
                <Box
                  aria-hidden="true"
                  sx={{ width: { xs: "100%", md: 600 }, maxWidth: "100%" }}
                >
                  <Lottie
                    animationData={unauthorized}
                    loop={true}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  />
                </Box>
                <Stack alignItems="center" sx={{ flex: 1 }}>
                  <EstadoError
                    titulo="¡No estás autorizado para estar aquí!"
                    mensaje="Comunícate con Sistemas."
                  />

                  <Button
                    onClick={() => {
                      navigate("/");
                      setIsUnautorized(false);
                    }}
                    variant="contained"
                    startIcon={<FontAwesomeIcon icon={faChevronCircleLeft} />}
                  >
                    Volver al Inicio
                  </Button>
                </Stack>
              </Stack>
            </Paper>
          </Container>
        </Dialog>
      </ThemeProvider>
    </div>
  );
};

export default Unautorized;
